import { createCustomAction } from 'typesafe-actions';

import { BatchesCollection } from '../BatchesList/typings';
import { Order } from '../common/typings';

export const loadItems = createCustomAction('@commonCreatives/LOAD_ITEMS', type => {
    return (offset: number, order: Order, sizes: string[]) => ({
        type,
        offset,
        order,
        sizes
    });
});
export const loadItemsSuccess = createCustomAction('@commonCreatives/LOAD_ITEMS_SUCCESS', type => {
    return (collection: BatchesCollection, sizes: string[]) => ({
        type,
        collection,
        sizes
    });
});
export const applySizesFilter = createCustomAction('@commonCreatives/APPLY_SIZES_FILTER', type => {
    return (sizes: string[]) => ({ type, sizes });
});
export const showError = createCustomAction('@commonCreatives/SHOW_ERROR', type => {
    return (message: string) => ({ type, message });
});
export const hideError = createCustomAction('@commonCreatives/HIDE_ERROR');
export const setSelection = createCustomAction('@commonCreatives/SET_SELECTION', type => {
    return (id: string, selected: boolean) => ({ type, id, selected });
});
export const saveName = createCustomAction('@commonCreatives/SAVE_NAME', type => {
    return (id: string, val: string) => ({ type, id, val });
});
export const saveNameSuccess = createCustomAction('@commonCreatives/SAVE_NAME_SUCCESS', type => {
    return (id: string, val: string) => ({ id, val, type });
});
export const deleteCreative = createCustomAction('@commonCreatives/DELETE_CREATIVE');
export const deleteCreativeSuccess = createCustomAction('@commonCreatives/DELETE_CREATIVE_SUCCESS', type => {
    return (id: string) => ({ id, type });
});
export const showDeleteConfirm = createCustomAction('@commonCreatives/SHOW_DELETE_CONFIRM', type => {
    return (id: string) => ({ type, id });
});
export const hideDeleteConfirm = createCustomAction('@commonCreatives/HIDE_DELETE_CONFIRM');
export const showCreativesSelector = createCustomAction('@commonCreatives/SHOW_CREATIVES_SELECTOR', type => {
    return (id: string) => ({ type, id });
});
export const hideCreativesSelector = createCustomAction('@commonCreatives/HIDE_CREATIVES_SELECTOR');
export const toggleSizesSelection = createCustomAction('@commonCreatives/TOGGLE_SIZES_SELECTION', type => {
    return (ids: number[], selected: boolean) => ({ type, ids, selected });
});
export const submitSizesSelection = createCustomAction('@commonCreatives/SUBMIT_SIZES_SELECTION');
export const submit = createCustomAction(
    '@commonCreatives/SUBMIT',
    type => (creativesSelect: (ids: number[]) => void) => ({ type, creativesSelect })
);

export type LoadItems = ReturnType<typeof loadItems>;
export type SaveName = ReturnType<typeof saveName>;
export type DeleteCreative = ReturnType<typeof deleteCreative>;
export type SubmitAction = ReturnType<typeof submit>;

export type CommonCreativesAction =
    | LoadItems
    | SaveName
    | DeleteCreative
    | SubmitAction
    | ReturnType<typeof deleteCreativeSuccess>
    | ReturnType<typeof loadItemsSuccess>
    | ReturnType<typeof applySizesFilter>
    | ReturnType<typeof setSelection>
    | ReturnType<typeof showError>
    | ReturnType<typeof hideError>
    | ReturnType<typeof saveNameSuccess>
    | ReturnType<typeof showDeleteConfirm>
    | ReturnType<typeof hideDeleteConfirm>
    | ReturnType<typeof showCreativesSelector>
    | ReturnType<typeof hideCreativesSelector>
    | ReturnType<typeof toggleSizesSelection>
    | ReturnType<typeof submitSizesSelection>
    | ReturnType<typeof submit>;
